import script from "./GabSolicitacaoViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GabSolicitacaoViewPage.vue?vue&type=script&setup=true&lang=js"

import "./GabSolicitacaoViewPage.vue?vue&type=style&index=0&id=33d9cb7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d9cb7f"]])

export default __exports__